const cache = {
  defaultUpdateIntervalInMilliseconds: 10 * 60 * 1000,
};

export default cache;



// WEBPACK FOOTER //
// ./src/constants/cache.js